/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, May 31st 2022, 6:44:58 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder } from "lib/validation";
import { Organization, User } from "lib/schemas";

/** SignUpInput */
export interface SignUpInput {
  email_address: string;
  confirm_email_address: string;
  organization_name: string;
  verification_base_url: string;
  phone_number?: string;
}

export const SignUpInputValidationSchema: schemaBuilder.SchemaOf<SignUpInput> = schemaBuilder.object({
  email_address: schemaBuilder
    .string()
    .required("Please enter your Email Address.")
    .email("Please enter a valid email address"),
  confirm_email_address: schemaBuilder
    .string()
    .required("Please confirm your email address.")
    .oneOf(
      [schemaBuilder.ref("email_address"), null],
      "Your email addresses are not matching. Please check that you are providing the correct email address."
    ),
  organization_name: schemaBuilder.string().required("Please enter your Organization's name."),
  verification_base_url: schemaBuilder.string().url().required("verification_base_url is required"),
  phone_number: schemaBuilder.string().required("Please provide us with your phone number."),
});

/** SSOSignUpInput */
export interface SSOSignUpInput {
  organization_name: Organization["name"];
}

export interface SSOSignUpResponse {
  organization: Organization;
  user: User;
}

export const SSOSignUpInputValidationSchema: schemaBuilder.SchemaOf<SSOSignUpInput> = schemaBuilder.object({
  organization_name: schemaBuilder.string().required("Please enter your Organization's name."),
});

/** ResetPasswordInput */
export interface ResetPasswordInput {
  email: string;
  password_confirmation_base_url: string;
}

export const ResetPasswordInputValidationSchema: schemaBuilder.SchemaOf<ResetPasswordInput> = schemaBuilder.object({
  email: schemaBuilder
    .string()
    .required("Please enter your Email Address.")
    .email("Please enter a valid email address"),
  password_confirmation_base_url: schemaBuilder.string().url().required("password_confirmation_base_url is required"),
});

/** ResetPasswordConfirmationInput */
export interface ResetPasswordConfirmationInput {
  uid: string;
  token: string;
  new_password1: string;
  new_password2: string;
}

export const ResetPasswordConfirmationInputValidationSchema: schemaBuilder.SchemaOf<ResetPasswordConfirmationInput> =
  schemaBuilder.object({
    uid: schemaBuilder.string().required(),
    token: schemaBuilder.string().required(),
    new_password1: schemaBuilder
      .string()
      .required("Please enter your password.")
      .min(8, "Password must be at least 8 characters long."),
    new_password2: schemaBuilder
      .string()
      .required("Please confirm your password.")
      .oneOf([schemaBuilder.ref("new_password1"), null], "Passwords are not matching. Please try again."),
  });
